@if (rows$ | async; as rows) {
  @if (rows.length) {
    <ul class="configured">
      @for (row of rows; track $index) {
        <li class="configured__row" data-test="configured-item">
          <span class="configured__label">{{ row.description }}</span>
          <strong class="configured__price">{{ row.total | localeCurrency: 'EUR' }}</strong>
          <plys-quantity-control
            class="configured__quantity"
            size="sm"
            [value]="row.quantity"
            [disabled]="!ticket && (canAddMore$ | async) !== true"
            [soldOutLabel]="product.soldOut ? ('product_options.sold_out' | transloco) : null"
            [displayLoading]="reserving$ | async"
            (increased)="add(row)"
            (decreased)="remove(row)"
          ></plys-quantity-control>
        </li>
      }
    </ul>
  }
}
